/* ==========================================================================
   WEBLY AGENCY OS — interactions du theme
   Vanilla, sans dependance. Chaque composant s'initialise UNIQUEMENT si son
   markup existe, et se re-initialise sur shopify:section:load pour rester
   utilisable dans l'editeur Shopify.
   ========================================================================== */
(function () {
  'use strict';

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hover = window.matchMedia && window.matchMedia('(hover:hover)').matches;
  var W = window.Webly || {};

  /* Chaque composant enregistre ici son nettoyage : sans cela, l'editeur
     Shopify empilerait un observer de plus a chaque rechargement de section. */
  var cleanups = [];
  function onCleanup(fn) { cleanups.push(fn); }

  function announce(msg) {
    var live = $('#a11y-live');
    if (live) { live.textContent = ''; setTimeout(function () { live.textContent = msg; }, 60); }
  }
  window.weblyAnnounce = announce;

  /* ====================================================== OVERLAYS
     Un gestionnaire unique pour modales, tiroir et lightbox : le verrouillage
     du scroll, le piege a focus et la pile de z-index doivent etre coherents,
     sinon deux overlays ouverts se disputent le focus et le scroll reste
     bloque apres fermeture. */
  var Overlay = (function () {
    var pile = [];
    var scrollY = 0;
    var SELECTEURS = 'a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])';

    function focusables(el) {
      return $$(SELECTEURS, el).filter(function (n) {
        return n.offsetWidth || n.offsetHeight || n.getClientRects().length;
      });
    }

    function piege(e) {
      if (e.key !== 'Tab' || !pile.length) return;
      var el = pile[pile.length - 1].el;
      var f = focusables(el);
      if (!f.length) { e.preventDefault(); return; }
      var premier = f[0], dernier = f[f.length - 1];
      if (e.shiftKey && document.activeElement === premier) { e.preventDefault(); dernier.focus(); }
      else if (!e.shiftKey && document.activeElement === dernier) { e.preventDefault(); premier.focus(); }
    }

    function echap(e) {
      if (e.key === 'Escape' && pile.length) { e.stopPropagation(); fermer(); }
    }

    function verrouille() {
      // On fige la page en `position:fixed` pour empecher le scroll d'arriere-plan
      // sur iOS, ou `overflow:hidden` seul ne suffit pas. La barre de defilement
      // est compensee pour que la page ne saute pas lateralement a l'ouverture.
      scrollY = window.pageYOffset;
      var barre = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.position = 'fixed';
      document.body.style.top = -scrollY + 'px';
      document.body.style.width = '100%';
      if (barre > 0) document.body.style.paddingRight = barre + 'px';
      document.body.classList.add('no-scroll');
    }
    function deverrouille() {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.style.paddingRight = '';
      document.body.classList.remove('no-scroll');
      window.scrollTo(0, scrollY);
    }

    function rendreInerte(el) {
      var noeuds = $$('#SiteHeader,#MobileMenu,#MainContent,.footer,#MobileBar,#CartToast');
      return noeuds.filter(function (n) {
        return n !== el && !n.contains(el) && !el.contains(n);
      }).map(function (n) {
        var etat = {
          el: n,
          inert: n.inert,
          avaitAria: n.hasAttribute('aria-hidden'),
          aria: n.getAttribute('aria-hidden')
        };
        n.inert = true;
        n.setAttribute('aria-hidden', 'true');
        return etat;
      });
    }

    function restaureInerte(etats) {
      (etats || []).forEach(function (etat) {
        etat.el.inert = etat.inert;
        if (etat.avaitAria) etat.el.setAttribute('aria-hidden', etat.aria);
        else etat.el.removeAttribute('aria-hidden');
      });
    }

    function ouvrir(el, opts) {
      if (!el) return;
      opts = opts || {};
      if (!pile.length) {
        verrouille();
        document.addEventListener('keydown', piege, true);
        document.addEventListener('keydown', echap, true);
      }
      pile.push({
        el: el,
        retour: document.activeElement,
        onClose: opts.onClose,
        inertes: opts.inert === false ? [] : rendreInerte(el)
      });
      el.classList.add('open');
      el.removeAttribute('aria-hidden');
      // Juste apres l'ajout de la classe, le navigateur n'a pas encore
      // recalcule les styles : l'overlay est toujours en `visibility:hidden`,
      // et focus() dans un sous-arbre invisible est sans effet — le clavier
      // resterait bloque derriere la modale.
      // La lecture de offsetWidth force ce recalcul de maniere SYNCHRONE.
      // On evite volontairement requestAnimationFrame : il ne s'execute pas
      // dans un onglet d'arriere-plan, et le focus n'arriverait jamais.
      void el.offsetWidth;
      var f = focusables(el);
      var cible = opts.focus || f[0] || el;
      if (cible === el && !el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
      cible.focus({ preventScroll: true });
      document.dispatchEvent(new CustomEvent('webly:overlay', { detail: { open: true, id: el.id || '' } }));
    }

    function fermer(cible) {
      if (!pile.length) return;
      var i = cible ? -1 : pile.length - 1;
      if (cible) for (var k = 0; k < pile.length; k++) if (pile[k].el === cible) i = k;
      if (i < 0) return;
      var entree = pile.splice(i, 1)[0];
      entree.el.classList.remove('open');
      entree.el.setAttribute('aria-hidden', 'true');
      restaureInerte(entree.inertes);
      if (entree.onClose) entree.onClose();
      if (!pile.length) {
        document.removeEventListener('keydown', piege, true);
        document.removeEventListener('keydown', echap, true);
        deverrouille();
      }
      if (entree.retour && entree.retour.focus) entree.retour.focus({ preventScroll: true });
      document.dispatchEvent(new CustomEvent('webly:overlay', { detail: { open: false, id: entree.el.id || '' } }));
    }

    return { ouvrir: ouvrir, fermer: fermer, actif: function () { return pile.length > 0; } };
  })();
  window.WeblyOverlay = Overlay;

  /* Fermeture au clic sur le fond, pour tout overlay. */
  document.addEventListener('click', function (e) {
    var ov = e.target.closest ? e.target.closest('.overlay,.drawer-scrim') : null;
    if (ov && e.target === ov) {
      Overlay.fermer(ov.classList.contains('drawer-scrim') ? $('#CartDrawer') : ov);
      if (ov.classList.contains('drawer-scrim')) ov.classList.remove('open');
    }
    /* Liens qui ouvrent une fenetre au lieu de naviguer.
       Le `href` est conserve dans le HTML : si ce script ne s'execute pas, le
       clic emmene sur la vraie page. On n'annule la navigation QUE si la
       fenetre visee existe reellement. */
    var lienModale = e.target.closest ? e.target.closest('[data-modale]') : null;
    if (lienModale && !e.defaultPrevented) {
      /* Un clic milieu, ou avec Ctrl/Cmd, veut dire « nouvel onglet ». On ne
         le detourne pas : ce serait reprendre a l'utilisateur un geste connu. */
      var neuf = e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1;
      var cible = document.querySelector(lienModale.getAttribute('data-modale'));
      if (cible && !neuf) {
        e.preventDefault();
        Overlay.ouvrir(cible);
        return;
      }
    }

    var fermeBtn = e.target.closest ? e.target.closest('[data-close]') : null;
    if (fermeBtn) {
      var parent = fermeBtn.closest('.overlay,.drawer');
      if (parent) {
        Overlay.fermer(parent);
        var scrim = $('.drawer-scrim');
        if (scrim) scrim.classList.remove('open');
      }
    }
  });

  /* ====================================================== NAVIGATION */
  function initNav() {
    var nav = $('#SiteHeader');
    if (!nav) return;
    var burger = $('#Burger', nav);
    var menu = $('#MobileMenu');

    function onScroll() { nav.classList.toggle('stuck', window.pageYOffset > 8); }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    onCleanup(function () { window.removeEventListener('scroll', onScroll); });

    if (burger && menu) {
      $$('a', menu).forEach(function (a, i) { a.style.setProperty('--i', i); });
      function fermeEtat() {
        nav.classList.remove('open');
        burger.setAttribute('aria-expanded', 'false');
        menu.setAttribute('aria-hidden', 'true');
      }
      function bascule(ouvert) {
        if (ouvert) {
          nav.classList.add('open');
          burger.setAttribute('aria-expanded', 'true');
          Overlay.ouvrir(menu, {
            focus: $('a,button', menu),
            inert: false,
            onClose: fermeEtat
          });
        } else {
          Overlay.fermer(menu);
          fermeEtat();
        }
      }
      function onBurger() { bascule(!menu.classList.contains('open')); }
      function onMenuClick(e) { if (e.target.closest('a')) bascule(false); }
      function onDocumentClick(e) {
        if (!menu.classList.contains('open')) return;
        if (!menu.contains(e.target) && !burger.contains(e.target)) bascule(false);
      }
      function onResize() { if (window.innerWidth > 960 && menu.classList.contains('open')) bascule(false); }
      burger.addEventListener('click', onBurger);
      menu.addEventListener('click', onMenuClick);
      document.addEventListener('click', onDocumentClick);
      window.addEventListener('resize', onResize);
      onCleanup(function () {
        burger.removeEventListener('click', onBurger);
        menu.removeEventListener('click', onMenuClick);
        document.removeEventListener('click', onDocumentClick);
        window.removeEventListener('resize', onResize);
      });
    }

    // Indicateur de section active
    var liens = $$('a[href^="#"]', nav).filter(function (a) { return a.getAttribute('href').length > 1; });
    if (!liens.length || !('IntersectionObserver' in window)) return;
    var cibles = liens.map(function (a) { return $(a.getAttribute('href')); }).filter(Boolean);
    if (!cibles.length) return;
    var io = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (en) {
        if (!en.isIntersecting) return;
        liens.forEach(function (a) {
          a.toggleAttribute('aria-current', a.getAttribute('href') === '#' + en.target.id);
        });
      });
    }, { rootMargin: '-45% 0px -50% 0px' });
    cibles.forEach(function (c) { io.observe(c); });
    onCleanup(function () { io.disconnect(); });
  }

  /* ====================================================== MODE CLAIR / SOMBRE
     Le mode est deja applique par le script synchrone du <head> : ici on ne
     gere que la bascule et la memorisation. Les captures de la demo existent
     en deux jeux, on echange donc aussi leur source. */
  function initScheme() {
    var html = document.documentElement;

    function majBouton() {
      var clair = html.getAttribute('data-scheme') === 'light';
      $$('[data-scheme-toggle]').forEach(function (b) {
        b.setAttribute('aria-pressed', clair ? 'true' : 'false');
        b.setAttribute('aria-label', clair ? 'Activer le mode sombre' : 'Activer le mode clair');
        var label = $('[data-scheme-label]', b);
        if (label) label.textContent = clair ? 'Activer le mode sombre' : 'Activer le mode clair';
        var use = $('[data-scheme-icon] use', b) || $('use', b);
        if (use) use.setAttribute('href', clair ? '#i-sun' : '#i-moon');
      });
    }

    function majCaptures() {
      var clair = html.getAttribute('data-scheme') === 'light';
      // Les deux jeux suivent la meme convention de nommage :
      //   module-<slug>-1400.webp        (sombre, jeu par defaut)
      //   module-<slug>-dark-1400.webp   (capture de l'app en mode sombre)
      // Le jeu "-dark" illustre l'application en sombre : il accompagne donc
      // le mode SOMBRE du site, et le jeu sans suffixe le mode clair.
      $$('img[src*="module-"]').forEach(function (im) {
        var src = im.getAttribute('src') || '';
        var voulu;
        if (clair) {
          voulu = src.replace('-dark-', '-');
        } else if (src.indexOf('-dark-') === -1) {
          // `$` ne fonctionne pas : Shopify suffixe ses assets d'un `?v=...`.
          voulu = src.replace(/-(\d+)\.webp(\?|$)/, '-dark-$1.webp$2');
        } else {
          voulu = src;
        }
        if (voulu !== src) im.setAttribute('src', voulu);
        var srcset = im.getAttribute('srcset');
        if (srcset) {
          var srcsetVoulu = clair ? srcset.replace(/-dark-/g, '-')
                                  : (srcset.indexOf('-dark-') === -1
                                     ? srcset.replace(/-(\d+)\.webp/g, '-dark-$1.webp') : srcset);
          if (srcsetVoulu !== srcset) im.setAttribute('srcset', srcsetVoulu);
        }
      });
      // La demo redessine sa scene depuis ses propres donnees : on la previent.
      if (typeof window.weblyRedessinerDemo === 'function') window.weblyRedessinerDemo();
    }

    majBouton();
    majCaptures();

    $$('[data-scheme-toggle]').forEach(function (b) {
      function onToggle() {
        var clair = html.getAttribute('data-scheme') === 'light';
        var neuf = clair ? 'dark' : 'light';
        html.setAttribute('data-scheme', neuf);
        try { localStorage.setItem('webly_scheme', neuf); } catch (e) {}
        majBouton();
        majCaptures();
        announce(neuf === 'light' ? 'Mode clair activé' : 'Mode sombre activé');
      }
      b.addEventListener('click', onToggle);
      onCleanup(function () { b.removeEventListener('click', onToggle); });
    });
  }

  /* ====================================================== REVELATIONS */
  function initReveals() {
    var els = $$('.rv');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
    // Filet : un defilement tres rapide ou un onglet ouvert en arriere-plan
    // peut priver l'observateur de son declenchement. Rien ne doit rester
    // invisible definitivement.
    var filet = setTimeout(function () {
      els.forEach(function (e) {
        if (e.getBoundingClientRect().top < window.innerHeight) e.classList.add('in');
      });
    }, 2500);
    onCleanup(function () { io.disconnect(); clearTimeout(filet); });
  }

  /* ====================================================== COMPTEURS
     La valeur finale est ecrite dans le HTML par Liquid : si le JS ne tourne
     pas, le chiffre juste est deja affiche. L'animation ne fait que partir
     de zero pour y revenir, une seule fois. */
  function initCounters() {
    var els = $$('[data-count]');
    if (!els.length || !('IntersectionObserver' in window)) return;
    if (reduce) return;
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        io.unobserve(el);
        var final = el.textContent;
        var cible = parseFloat(el.getAttribute('data-count'));
        if (isNaN(cible)) return;
        var t0 = 0, duree = 1100;
        function pas(ts) {
          if (!t0) t0 = ts;
          var p = Math.min(1, (ts - t0) / duree);
          var v = Math.round(cible * (1 - Math.pow(1 - p, 3)));
          el.textContent = v.toLocaleString('fr-FR');
          if (p < 1) requestAnimationFrame(pas); else el.textContent = final;
        }
        requestAnimationFrame(pas);
      });
    }, { threshold: 0.4 });
    els.forEach(function (e) { io.observe(e); });
    onCleanup(function () { io.disconnect(); });
  }

  /* ====================================================== FAQ */
  function initFaq() {
    $$('[data-faq]').forEach(function (racine) {
      var solo = racine.getAttribute('data-faq') === 'single';
      var btns = $$('.q-btn', racine);
      btns.forEach(function (btn) {
        var corps = document.getElementById(btn.getAttribute('aria-controls'));
        if (!corps) return;
        btn.addEventListener('click', function () {
          var ouvert = btn.getAttribute('aria-expanded') === 'true';
          if (solo && !ouvert) {
            btns.forEach(function (o) {
              if (o === btn) return;
              var c = document.getElementById(o.getAttribute('aria-controls'));
              o.setAttribute('aria-expanded', 'false');
              if (c) c.style.height = '0px';
            });
          }
          btn.setAttribute('aria-expanded', ouvert ? 'false' : 'true');
          // Hauteur reelle mesuree : `auto` ne s'anime pas.
          corps.style.height = ouvert ? '0px' : corps.firstElementChild.offsetHeight + 'px';
        });
        // Navigation clavier entre questions
        btn.addEventListener('keydown', function (e) {
          var i = btns.indexOf(btn), n = null;
          if (e.key === 'ArrowDown') n = btns[(i + 1) % btns.length];
          else if (e.key === 'ArrowUp') n = btns[(i - 1 + btns.length) % btns.length];
          else if (e.key === 'Home') n = btns[0];
          else if (e.key === 'End') n = btns[btns.length - 1];
          if (n) { e.preventDefault(); n.focus(); }
        });
      });
      // Une reponse ouverte doit suivre le redimensionnement du texte.
      var rz = function () {
        btns.forEach(function (b) {
          if (b.getAttribute('aria-expanded') !== 'true') return;
          var c = document.getElementById(b.getAttribute('aria-controls'));
          if (c) c.style.height = c.firstElementChild.offsetHeight + 'px';
        });
      };
      window.addEventListener('resize', rz);
      onCleanup(function () { window.removeEventListener('resize', rz); });
    });
  }

  /* ============================================ FAQ : repli « Afficher plus »
     Dix questions ouvertes d'un coup decouragent la lecture. On en montre
     quelques-unes, le reste est accessible en un clic — et reste dans le HTML,
     donc indexable et lisible par un lecteur d'ecran. */
  function initFaqRepli() {
    $$('[data-faq-max]').forEach(function (racine) {
      var max = parseInt(racine.getAttribute('data-faq-max'), 10) || 6;
      var qs = $$('.q', racine);
      if (qs.length <= max) return;
      racine.classList.add('is-clamped');
      qs.forEach(function (q, i) { if (i >= max) q.classList.add('beyond'); });

      var wrap = document.createElement('div');
      wrap.className = 'faq-more';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'btn btn-ghost';
      var reste = qs.length - max;
      btn.innerHTML = '<span class="lbl">Afficher ' + reste + ' question' +
                      (reste > 1 ? 's' : '') + ' de plus</span>';
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', function () {
        var ouvert = racine.classList.toggle('is-clamped') === false;
        btn.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
        $('.lbl', btn).textContent = ouvert ? 'Afficher moins'
                                            : 'Afficher ' + reste + ' question' + (reste > 1 ? 's' : '') + ' de plus';
      });
      wrap.appendChild(btn);
      racine.parentNode.insertBefore(wrap, racine.nextSibling);
    });
  }

  /* ============================================ CARROUSEL D'AVIS
     Defilement pilote par `scrollTo` sur une piste a accroche native : aucun
     glissement simule, donc le scroll vertical de la page reste intact et le
     rebond iOS est preserve. */
  function initAvis() {
    $$('[data-avis]').forEach(function (racine) {
      var piste = $('[data-avis-piste]', racine);
      if (!piste) return;
      var cartes = $$('.avis', piste);
      if (cartes.length < 2) return;

      var points = $('[data-avis-points]', racine);
      var status = $('[data-avis-status]', racine);
      var toggle = $('[data-avis-toggle]', racine);
      var auto = null, visible = true, pauseUtilisateur = false;
      var actionUtilisateur = false, timerScroll = null, dernierePage = -1, dernierePageAnnoncee = -1;

      function parVue() {
        // Nombre de cartes reellement visibles : evite des points inutiles
        // quand trois avis tiennent deja cote a cote.
        return Math.max(1, Math.round(piste.clientWidth / cartes[0].offsetWidth));
      }
      function pages() { return Math.max(1, Math.ceil(cartes.length / parVue())); }
      function pageCourante() {
        var rp = piste.getBoundingClientRect();
        var gauche = piste.scrollLeft;
        var meilleur = 0, distance = Infinity;
        for (var n = 0; n < pages(); n++) {
          var carte = cartes[Math.min(cartes.length - 1, n * parVue())];
          var pos = carte.getBoundingClientRect().left - rp.left + gauche;
          var ecart = Math.abs(pos - gauche);
          if (ecart < distance) { distance = ecart; meilleur = n; }
        }
        return meilleur;
      }

      function construirePoints() {
        if (!points) return;
        points.innerHTML = '';
        for (var i = 0; i < pages(); i++) {
          (function (n) {
            var b = document.createElement('button');
            b.type = 'button';
            b.setAttribute('aria-label', 'Afficher la page d’avis ' + (n + 1) + ' sur ' + pages());
            var carte = cartes[Math.min(cartes.length - 1, n * parVue())];
            if (carte && carte.id) b.setAttribute('aria-controls', carte.id);
            b.addEventListener('click', function () {
              actionUtilisateur = true;
              aller(n);
              stop();
            });
            points.appendChild(b);
          })(i);
        }
        majPoints();
      }
      function majPoints(annoncer) {
        if (!points) return;
        var cur = Math.max(0, Math.min(pageCourante(), pages() - 1));
        $$('button', points).forEach(function (b, i) {
          if (i === cur) b.setAttribute('aria-current', 'true');
          else b.removeAttribute('aria-current');
        });
        cartes.forEach(function (c, i) {
          c.toggleAttribute('aria-current', i === Math.min(cartes.length - 1, cur * parVue()));
        });
        if (annoncer && status && cur !== dernierePageAnnoncee) {
          var debut = Math.min(cartes.length - 1, cur * parVue());
          var fin = Math.min(cartes.length, debut + parVue());
          var auteur = cartes[debut] ? cartes[debut].getAttribute('data-avis-author') : '';
          status.textContent = 'Avis ' + (debut + 1) + (fin > debut + 1 ? ' à ' + fin : '') +
            ' sur ' + cartes.length + (auteur ? ', à partir de ' + auteur : '');
          dernierePageAnnoncee = cur;
        }
        dernierePage = cur;
      }
      function aller(n) {
        var carte = cartes[Math.min(cartes.length - 1, n * parVue())];
        if (!carte) return;
        var rp = piste.getBoundingClientRect();
        var cible = carte.getBoundingClientRect().left - rp.left + piste.scrollLeft;
        piste.scrollTo({ left: cible, behavior: reduce ? 'auto' : 'smooth' });
      }
      function bouger(pas) {
        var n = pageCourante() + pas;
        if (n < 0) n = pages() - 1;
        if (n >= pages()) n = 0;
        aller(n);
      }

      var prev = $('[data-avis-prev]', racine), next = $('[data-avis-next]', racine);
      if (prev) prev.addEventListener('click', function () { actionUtilisateur = true; bouger(-1); stop(); });
      if (next) next.addEventListener('click', function () { actionUtilisateur = true; bouger(1); stop(); });

      piste.addEventListener('pointerdown', function () { actionUtilisateur = true; stop(); }, { passive: true });
      piste.addEventListener('scroll', function () {
        majPoints(false);
        clearTimeout(timerScroll);
        timerScroll = setTimeout(function () {
          majPoints(actionUtilisateur);
          actionUtilisateur = false;
        }, 160);
      }, { passive: true });
      window.addEventListener('resize', construirePoints);
      onCleanup(function () { window.removeEventListener('resize', construirePoints); });

      /* Defilement automatique : suspendu au survol, au focus clavier, onglet
         masque et section hors ecran. Jamais lance sous reduction d'animation
         — un carrousel qui bouge tout seul est un obstacle pour beaucoup de
         personnes. */
      function demarrer() {
        if (reduce || auto || !visible || pauseUtilisateur) return;
        if (racine.contains(document.activeElement)) return;
        if (racine.getAttribute('data-avis-auto') === 'false') return;
        auto = setInterval(function () { bouger(1); }, 5200);
      }
      function stop() { if (auto) { clearInterval(auto); auto = null; } }

      function majToggle() {
        if (!toggle) return;
        toggle.setAttribute('aria-pressed', pauseUtilisateur ? 'true' : 'false');
        toggle.setAttribute('aria-label', pauseUtilisateur ? 'Relancer le défilement automatique' : 'Mettre le défilement en pause');
        var signe = $('span', toggle);
        if (signe) signe.textContent = pauseUtilisateur ? '▶' : 'Ⅱ';
      }
      if (toggle) toggle.addEventListener('click', function () {
        pauseUtilisateur = !pauseUtilisateur;
        if (pauseUtilisateur) stop(); else demarrer();
        majToggle();
      });

      /* PAS DE MISE EN PAUSE AU SURVOL.
         Elle paraissait raisonnable, elle rendait le carrousel inutilisable :
         la section occupe toute la largeur et 400 px de haut, si bien qu'en
         faisant defiler la page le curseur se pose dessus et n'en bouge plus.
         Mesure sur le site en ligne, souris posee au centre de la section :
         scrollLeft 4 -> 4 -> 4 -> 4 -> 4 pendant douze secondes, contre
         4 -> 1208 -> 2412 sans la souris. Le carrousel semblait casse.

         Le controle exige par les regles d'accessibilite reste assure par le
         bouton de pause, qui est explicite et memorise le choix. On conserve
         aussi la pause au focus clavier, hors ecran et onglet masque. */
      racine.addEventListener('focusin', stop);
      racine.addEventListener('focusout', function () {
        setTimeout(function () { if (!racine.contains(document.activeElement)) demarrer(); }, 0);
      });
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop(); else demarrer();
      });
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) {
          visible = en[0].isIntersecting;
          if (visible) demarrer(); else stop();
        }, { threshold: 0.25 });
        io.observe(racine);
        onCleanup(function () { io.disconnect(); });
      } else {
        // Sans IntersectionObserver, plus personne n'appelait `demarrer` :
        // le carrousel restait immobile pour toujours sur ces navigateurs.
        demarrer();
      }
      onCleanup(function () { stop(); clearTimeout(timerScroll); });

      piste.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); actionUtilisateur = true; bouger(1); stop(); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); actionUtilisateur = true; bouger(-1); stop(); }
      });

      construirePoints();
      majToggle();
      demarrer();
    });
  }

  /* ====================================================== HERO */
  function initHero() {
    var shot = $('[data-hero-shot]');
    if (!shot || !hover || reduce || document.body.classList.contains('anim-none')) return;
    shot.classList.add('tilt');
    var tick = false;
    function frame() {
      tick = false;
      var y = window.pageYOffset, vh = window.innerHeight;
      var flat = Math.max(0, Math.min(1, y / (vh * 0.5)));
      shot.style.setProperty('--flat', flat.toFixed(3));
    }
    function onS() { if (!tick) { tick = true; requestAnimationFrame(frame); } }
    window.addEventListener('scroll', onS, { passive: true });
    frame();
    onCleanup(function () { window.removeEventListener('scroll', onS); });
  }

  /* ====================================================== HALO POINTEUR */
  function initSpot() {
    if (!hover || reduce || document.body.classList.contains('anim-none')) return;
    $$('[data-spot]').forEach(function (c) {
      c.classList.add('spot');
      c.addEventListener('pointermove', function (e) {
        var r = c.getBoundingClientRect();
        c.style.setProperty('--sx', (e.clientX - r.left) + 'px');
        c.style.setProperty('--sy', (e.clientY - r.top) + 'px');
      });
    });
  }

  /* ====================================================== LIGHTBOX */
  function initLightbox() {
    var lb = $('#Lightbox');
    if (!lb) return;
    var img = $('#LightboxImg', lb), leg = $('#LightboxCap', lb);
    function ouvrir(t) {
      if (!t || !img) return;
      img.src = t.getAttribute('data-lightbox');
      img.alt = t.getAttribute('data-lightbox-alt') || '';
      img.hidden = false;
      if (leg) leg.textContent = t.getAttribute('data-lightbox-cap') || '';
      Overlay.ouvrir(lb, { onClose: function () {
        img.hidden = true;
        img.removeAttribute('src');
        img.alt = '';
        if (leg) leg.textContent = '';
      } });
    }
    function onClick(e) {
      var t = e.target.closest ? e.target.closest('[data-lightbox]') : null;
      if (!t) return;
      e.preventDefault();
      ouvrir(t);
    }
    function onKey(e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var t = e.target.closest ? e.target.closest('[data-lightbox]') : null;
      if (!t || /^(BUTTON|A)$/.test(t.tagName)) return;
      e.preventDefault();
      ouvrir(t);
    }
    document.addEventListener('click', onClick);
    document.addEventListener('keydown', onKey);
    onCleanup(function () {
      document.removeEventListener('click', onClick);
      document.removeEventListener('keydown', onKey);
    });
  }

  function initContact() {
    var form = $('.contact-form');
    if (!form) return;
    function onSubmit() {
      if (!form.checkValidity()) return;
      var btn = $('[data-contact-submit]', form);
      if (!btn) return;
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
    }
    form.addEventListener('submit', onSubmit);
    onCleanup(function () { form.removeEventListener('submit', onSubmit); });
  }

  function initVisibilityAnimations() {
    function maj() { document.body.classList.toggle('page-hidden', document.hidden); }
    document.addEventListener('visibilitychange', maj);
    maj();
    onCleanup(function () { document.removeEventListener('visibilitychange', maj); });
  }

  /* ====================================================== DEMO MODULES */
  function initDemo() {
    var racine = $('[data-demo]');
    if (!racine) return;

    var donnees;
    try { donnees = JSON.parse($('[data-demo-json]', racine).textContent); }
    catch (e) { return; }
    if (!donnees || !donnees.length) return;

    var idx = 0, famille = 'tout', autoplay = null, visible = true;
    var positionsMobile = { tout: 0 }, positionsDesktop = { tout: 0 };
    var imgA = $('[data-demo-a]', racine), imgB = $('[data-demo-b]', racine);
    var actif = imgA;
    var elCat = $('[data-demo-cat]', racine), elTitre = $('[data-demo-title]', racine);
    var elFenetre = $('[data-demo-window-title]', racine);
    var elDesc = $('[data-demo-desc]', racine), elCount = $('[data-demo-count]', racine);
    var panneau = $('[data-demo-panel]', racine);
    var demoLightbox = $('[data-demo-lightbox]', racine);
    var items = $$('[data-demo-item]', racine);
    var pills = $$('[data-demo-fam]', racine);

    function liste() {
      return donnees.map(function (d, i) { return i; })
        .filter(function (i) { return famille === 'tout' || donnees[i].fam === famille; });
    }

    /* Les captures existent en deux ambiances. On derive la variante sombre
       du nom de fichier — en tenant compte du `?v=` que Shopify ajoute a
       toutes les URL d'assets, sinon l'expression ne trouve jamais rien. */
    function source(d) {
      var base = d.src;
      if (document.documentElement.getAttribute('data-scheme') === 'light') return base;
      if (base.indexOf('-dark-') !== -1) return base;
      return base.replace(/-(\d+)\.webp(\?|$)/, '-dark-$1.webp$2');
    }

    function precharge(i) {
      if (window.matchMedia && window.matchMedia('(max-width:960px)').matches) return;
      var l = liste(); var p = l.indexOf(i);
      if (p < 0) return;
      var suiv = l[(p + 1) % l.length];
      if (donnees[suiv]) { var im = new Image(); im.src = source(donnees[suiv]); }
    }

    function afficher(i, focus, annoncer) {
      var d = donnees[i];
      if (!d) return;
      idx = i;
      var voulue = source(d);
      // La premiere capture est deja rendue par Liquid. Dans ce cas on NE
      // permute PAS : `entrant` vaudrait `actif`, et poser() ajouterait la
      // classe avant de la retirer sur le meme element — l'ecran resterait
      // noir, et le resterait pour toutes les captures suivantes.
      if (actif.getAttribute('src') === voulue) {
        actif.classList.add('on');
      } else {
        // Fondu croise sur deux calques : un seul <img> dont on change `src`
        // provoquerait un flash blanc pendant le decodage.
        var entrant = actif === imgA ? imgB : imgA;
        var sortant = actif;
        entrant.src = voulue;
        // Repli sur le titre du module : une capture produit porte de
        // l'information, la laisser sans description la rend muette.
        entrant.alt = d.alt || d.title || '';
        var poser = function () {
          entrant.classList.add('on');
          if (sortant !== entrant) sortant.classList.remove('on');
          // `aria-hidden` doit suivre la visibilite, pas rester sur le calque
          // ou il a ete pose au chargement. Sans ces deux lignes, apres le
          // premier changement de module, le lecteur d'ecran annoncait la
          // capture MASQUEE et passait sous silence celle qui est affichee.
          entrant.removeAttribute('aria-hidden');
          if (sortant !== entrant) sortant.setAttribute('aria-hidden', 'true');
          actif = entrant;
        };
        if (entrant.complete) poser(); else entrant.onload = poser;
      }

      if (elCat) elCat.textContent = d.fam;
      if (elTitre) elTitre.textContent = d.title;
      if (elFenetre) elFenetre.textContent = d.title;
      if (elDesc) elDesc.textContent = d.desc;
      if (panneau) {
        panneau.setAttribute('aria-labelledby', items[i] ? items[i].id : '');
      }
      if (demoLightbox) {
        demoLightbox.setAttribute('data-lightbox', voulue);
        demoLightbox.setAttribute('data-lightbox-alt', d.alt || d.title || '');
        demoLightbox.setAttribute('data-lightbox-cap', d.title || '');
        demoLightbox.setAttribute('aria-label', 'Agrandir la capture ' + (d.title || 'du module'));
      }
      var l = liste();
      if (elCount) elCount.textContent = (l.indexOf(i) + 1) + ' / ' + l.length;
      items.forEach(function (b, k) {
        var on = k === i;
        b.setAttribute('aria-current', on ? 'true' : 'false');
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
        if (on && focus) b.focus();
        if (on) {
          // Defilement contenu dans la barre laterale : scrollIntoView ferait
          // remonter la fenetre entiere quand la section est hors ecran.
          var box = b.parentNode, rb = b.getBoundingClientRect(), rp = box.getBoundingClientRect();
          if (rb.top < rp.top) box.scrollTop -= (rp.top - rb.top) + 8;
          else if (rb.bottom > rp.bottom) box.scrollTop += (rb.bottom - rp.bottom) + 8;
        }
      });
      precharge(i);
      if (annoncer !== false) announce(d.title);
    }

    function bouger(pas, focus, annoncer) {
      var l = liste();
      var p = l.indexOf(idx);
      if (p < 0) p = 0;
      afficher(l[(p + pas + l.length) % l.length], focus, annoncer);
    }

    items.forEach(function (b, k) {
      b.addEventListener('click', function () { afficher(k); stop(); });
    });
    var prev = $('[data-demo-prev]', racine), next = $('[data-demo-next]', racine);
    if (prev) prev.addEventListener('click', function () { bouger(-1); stop(); });
    if (next) next.addEventListener('click', function () { bouger(1); stop(); });

    var diapos = $$('.dm-slide', racine);
    var piste = $('[data-demo-track]', racine);
    var mCount = $('[data-demo-mcount]', racine);
    var mProgress = $('[data-demo-progress]', racine);
    var mProgressWrap = $('[data-demo-progress-wrap]', racine);
    var dernierMobile = -1, dernierAnnonceMobile = -1;

    function diaposVisibles() {
      return diapos.filter(function (d) { return !d.hidden; });
    }
    function indexMobile() {
      var vis = diaposVisibles();
      if (!piste || !vis.length) return 0;
      var rp = piste.getBoundingClientRect();
      var gauche = piste.scrollLeft;
      var meilleur = 0, distance = Infinity;
      vis.forEach(function (d, i) {
        var pos = d.getBoundingClientRect().left - rp.left + gauche;
        var ecart = Math.abs(pos - gauche);
        if (ecart < distance) { distance = ecart; meilleur = i; }
      });
      return meilleur;
    }
    function majMobile(annoncer) {
      var vis = diaposVisibles();
      if (!vis.length) return;
      var i = Math.max(0, Math.min(indexMobile(), vis.length - 1));
      vis.forEach(function (d, k) {
        d.toggleAttribute('aria-current', k === i);
        d.setAttribute('aria-label', (k + 1) + ' sur ' + vis.length + ' — ' +
          (($('h3', d) || {}).textContent || 'Module'));
      });
      if (mCount) mCount.textContent = (i + 1) + ' / ' + vis.length;
      if (mProgress) mProgress.style.width = (((i + 1) / vis.length) * 100) + '%';
      if (mProgressWrap) {
        mProgressWrap.setAttribute('aria-valuemax', vis.length);
        mProgressWrap.setAttribute('aria-valuenow', i + 1);
      }
      positionsMobile[famille] = i;
      if (annoncer && i !== dernierAnnonceMobile) {
        var titre = $('h3', vis[i]);
        announce('Module ' + (i + 1) + ' sur ' + vis.length + (titre ? ' : ' + titre.textContent : ''));
        dernierAnnonceMobile = i;
      }
      dernierMobile = i;
    }
    function allerMobile(i, behavior, annoncer) {
      var vis = diaposVisibles();
      if (!piste || !vis.length) return;
      i = Math.max(0, Math.min(i, vis.length - 1));
      var rp = piste.getBoundingClientRect();
      var pos = vis[i].getBoundingClientRect().left - rp.left + piste.scrollLeft;
      piste.scrollTo({ left: pos, behavior: behavior || (reduce ? 'auto' : 'smooth') });
      positionsMobile[famille] = i;
      if (annoncer) {
        var titre = $('h3', vis[i]);
        announce('Module ' + (i + 1) + ' sur ' + vis.length + (titre ? ' : ' + titre.textContent : ''));
        dernierAnnonceMobile = i;
      }
    }

    pills.forEach(function (p, pillIndex) {
      p.tabIndex = pillIndex === 0 ? 0 : -1;
      p.addEventListener('click', function () {
        positionsDesktop[famille] = Math.max(0, liste().indexOf(idx));
        positionsMobile[famille] = indexMobile();
        famille = p.getAttribute('data-demo-fam');
        pills.forEach(function (o) {
          var on = o === p;
          o.setAttribute('aria-selected', on ? 'true' : 'false');
          o.tabIndex = on ? 0 : -1;
        });
        items.forEach(function (b, k) {
          b.hidden = !(famille === 'tout' || donnees[k].fam === famille);
        });
        // Le carrousel mobile doit suivre le meme filtre : sans cela, cliquer
        // une famille sur telephone ne produisait aucun effet visible, car
        // seule la version bureau — masquee — etait mise a jour.
        diapos.forEach(function (d, k) {
          d.hidden = !(famille === 'tout' || donnees[k].fam === famille);
        });
        var l = liste();
        var posDesktop = Math.min(positionsDesktop[famille] || 0, Math.max(0, l.length - 1));
        if (l.length) afficher(l[posDesktop]);
        dernierMobile = -1;
        dernierAnnonceMobile = -1;
        requestAnimationFrame(function () {
          allerMobile(positionsMobile[famille] || 0, 'auto');
          majMobile(false);
        });
        stop();
      });
      p.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft' && e.key !== 'Home' && e.key !== 'End') return;
        e.preventDefault();
        var cible = pillIndex;
        if (e.key === 'ArrowRight') cible = (pillIndex + 1) % pills.length;
        else if (e.key === 'ArrowLeft') cible = (pillIndex - 1 + pills.length) % pills.length;
        else if (e.key === 'Home') cible = 0;
        else if (e.key === 'End') cible = pills.length - 1;
        pills[cible].focus();
        pills[cible].click();
      });
    });

    racine.addEventListener('keydown', function (e) {
      if (!e.target.closest('.demo-desktop')) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); bouger(1, true); stop(); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); bouger(-1, true); stop(); }
    });

    /* Lecture automatique : suspendue au survol, au focus, quand l'onglet est
       masque et quand la section quitte l'ecran. Jamais active si le visiteur
       demande a reduire les animations. */
    var btnPlay = $('[data-demo-play]', racine);
    function demarrer() {
      if (reduce || autoplay || !visible) return;
      autoplay = setInterval(function () { bouger(1, false, false); }, 4200);
      if (btnPlay) btnPlay.setAttribute('aria-pressed', 'true');
    }
    function stop() {
      if (autoplay) { clearInterval(autoplay); autoplay = null; }
      if (btnPlay) btnPlay.setAttribute('aria-pressed', 'false');
    }
    if (btnPlay) {
      btnPlay.addEventListener('click', function () { autoplay ? stop() : demarrer(); });
    }
    /* Meme correctif que pour le carrousel d'avis : la mise en pause au survol
       arretait la lecture des l'instant ou l'on posait la souris pour
       regarder — et aucun `pointerleave` ne la relancait. On appuyait sur
       « lecture », on approchait le curseur, et tout se figeait pour de bon.
       Le bouton de lecture reste le controle explicite. */
    racine.addEventListener('focusin', stop);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
    });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) {
        visible = en[0].isIntersecting;
        if (!visible) stop();
      }, { threshold: 0.25 });
      io.observe(racine);
      onCleanup(function () { io.disconnect(); });
    }
    onCleanup(stop);

    /* --- Version mobile : defilement natif avec accroche, pas de swipe
       simule. Le geste vertical de la page reste donc totalement libre. */
    if (piste) {
      var mobileRaf = false, mobileSettle = null;
      piste.addEventListener('scroll', function () {
        if (mobileRaf) return;
        mobileRaf = true;
        requestAnimationFrame(function () { mobileRaf = false; majMobile(false); });
        clearTimeout(mobileSettle);
        mobileSettle = setTimeout(function () { majMobile(true); }, 180);
      }, { passive: true });
      piste.addEventListener('scrollend', function () { majMobile(true); });
      piste.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        allerMobile(indexMobile() + (e.key === 'ArrowRight' ? 1 : -1), undefined, true);
      });
      majMobile(false);
      var mp = $('[data-demo-mprev]', racine), mn = $('[data-demo-mnext]', racine);
      var glisse = function (d) {
        allerMobile(indexMobile() + d, undefined, true);
      };
      if (mp) mp.addEventListener('click', function () { glisse(-1); });
      if (mn) mn.addEventListener('click', function () { glisse(1); });
    }

    /* Les diapositives mobiles sont rendues par Liquid en version claire :
       on les aligne sur le mode courant, sinon la demo reste blanche en mode
       sombre sur telephone. */
    function majDiapos() {
      var clair = document.documentElement.getAttribute('data-scheme') === 'light';
      $$('.dm-slide img', racine).forEach(function (im) {
        var src = im.getAttribute('src') || '';
        var voulu = clair ? src.replace('-dark-', '-')
                          : (src.indexOf('-dark-') === -1
                             ? src.replace(/-(\d+)\.webp(\?|$)/, '-dark-$1.webp$2') : src);
        if (voulu !== src) im.setAttribute('src', voulu);
        var ss = im.getAttribute('srcset');
        if (ss) {
          var vs = clair ? ss.replace(/-dark-/g, '-')
                         : (ss.indexOf('-dark-') === -1
                            ? ss.replace(/-(\d+)\.webp/g, '-dark-$1.webp') : ss);
          if (vs !== ss) im.setAttribute('srcset', vs);
        }
        var trigger = im.closest('[data-lightbox]');
        if (trigger) {
          var grand = trigger.getAttribute('data-lightbox') || '';
          var grandVoulu = clair ? grand.replace('-dark-', '-')
                                 : (grand.indexOf('-dark-') === -1
                                    ? grand.replace(/-(\d+)\.webp(\?|$)/, '-dark-$1.webp$2') : grand);
          if (grandVoulu !== grand) trigger.setAttribute('data-lightbox', grandVoulu);
        }
      });
    }
    majDiapos();

    window.weblyRedessinerDemo = function () { afficher(idx, false, false); majDiapos(); };

    afficher(0, false, false);
  }

  /* ====================================================== INITIALISATION */
  /* ------------------------------------------------------------------ */
  /* Confort de lecture des articles.                                     */
  /*                                                                      */
  /* Trois interventions, toutes sur du contenu saisi dans l'editeur      */
  /* Shopify — donc sur du HTML qu'on ne controle pas a la source.        */
  /* ------------------------------------------------------------------ */
  function initEditorial() {
    /* TOUS les blocs de contenu, pas seulement le premier.
       La page d'accueil en compte desormais trois — un par guide deplie.
       Ne traiter que le premier laissait deux guides sans tableaux enrobes. */
    var blocs = $$('.prose');
    if (!blocs.length) return;

    /* 1. Enrobage des tableaux.
       L'editeur Shopify produit un <table> nu. Pour qu'un tableau large
       puisse defiler sans elargir la page, il lui faut un conteneur — que
       l'on ne peut pas demander a l'auteur d'ecrire a la main. */
    $$('.prose table').forEach(function (t) {
      if (t.parentNode && t.parentNode.classList.contains('table-wrap')) return;
      var box = document.createElement('div');
      box.className = 'table-wrap';
      /* Un conteneur qui defile doit etre atteignable au clavier, sinon son
         contenu est inaccessible sans souris. */
      box.setAttribute('tabindex', '0');
      box.setAttribute('role', 'region');
      var titre = t.querySelector('caption');
      box.setAttribute('aria-label', titre ? titre.textContent.trim() : 'Tableau');
      t.parentNode.insertBefore(box, t);
      box.appendChild(t);
    });

    /* 2. Temps de lecture — uniquement si personne ne l'a deja pose.
       Les guides le calculent en Liquid, cote serveur : il reste juste meme
       si ce script n'a pas tourne. On ne remplit donc que les emplacements
       laisses vides, ceux des articles de blog. */
    $$('[data-temps-lecture]').forEach(function (cible) {
      if (cible.textContent.trim()) return;
      var bloc = cible.closest('article, .shopify-section') || document;
      var contenu = bloc.querySelector('.prose');
      if (!contenu) return;
      var mots = (contenu.textContent || '').trim().split(/\s+/).length;
      cible.textContent = Math.max(1, Math.round(mots / 200)) + ' min de lecture';
    });

    /* 3. Barre de progression — pages de lecture SEULEMENT.
       `.art-colonne` n'existe que sur un article. Sur la page d'accueil, qui
       porte desormais trois guides, une barre de progression indiquerait la
       lecture d'une page de vente : contresens, et bruit visuel. */
    if (reduce || !$('.art-colonne')) return;
    var barre = document.createElement('div');
    barre.className = 'lire-progres';
    barre.setAttribute('aria-hidden', 'true');
    document.body.appendChild(barre);

    var tic = false;
    function majProgres() {
      var h = document.documentElement;
      var total = h.scrollHeight - h.clientHeight;
      var pct = total > 0 ? (h.scrollTop / total) * 100 : 0;
      barre.style.width = Math.min(100, Math.max(0, pct)) + '%';
      tic = false;
    }
    function auDefilement() {
      if (tic) return;
      tic = true;
      requestAnimationFrame(majProgres);
    }
    window.addEventListener('scroll', auDefilement, { passive: true });
    window.addEventListener('resize', auDefilement, { passive: true });
    majProgres();

    onCleanup(function () {
      window.removeEventListener('scroll', auDefilement);
      window.removeEventListener('resize', auDefilement);
      if (barre.parentNode) barre.parentNode.removeChild(barre);
    });
  }

  /* ============================================ LE TELEPHONE QUI DEFILE */
  /* La capture fait 4,5 ecrans de haut. Elle avance AU RYTHME DE LA PAGE :
     le visiteur descend, l'application se deroule dans l'appareil. Rien a
     cliquer, rien a attendre.

     POURQUOI PAS UNE BOUCLE AUTOMATIQUE. Une animation qui tourne toute seule
     part avant qu'on la regarde et revient quand on est ailleurs. Liee au
     defilement, elle est toujours a l'endroit ou l'oeil se trouve.

     POURQUOI PAS UN `transform`. Le conteneur defile pour de vrai, donc le
     doigt et la molette fonctionnent dessus. Des que le visiteur s'en sert,
     on lache la main : c'est le sien, pas le notre. */
  function initPoche() {
    $$('[data-poche]').forEach(function (ecran) {
      var img = ecran.querySelector('.poche-img');
      if (!img) return;

      /* Mouvement reduit : on ne pilote rien, mais le conteneur reste
         parcourable au doigt et au clavier. */
      if (reduce || document.body.classList.contains('anim-none')) return;

      var libre = false;   // le visiteur a pris la main
      var tick = false;
      var course = 0;

      function mesurer() { course = Math.max(0, ecran.scrollHeight - ecran.clientHeight); }

      function frame() {
        tick = false;
        if (libre) return;
        if (!course) { mesurer(); if (!course) return; }

        var r = ecran.getBoundingClientRect(), vh = window.innerHeight;
        /* On n'avance que pendant la traversee reelle de l'ecran. Demarrer des
           que l'appareil pointe en bas ferait defiler l'application avant
           qu'on ait eu le temps de la voir. */
        var debut = vh * 0.88;
        var fin = vh * 0.12 - r.height;
        var plage = debut - fin;
        var p = (debut - r.top) / plage;
        p = p < 0 ? 0 : (p > 1 ? 1 : p);

        /* ON NE DEROULE PAS TOUT AUTOMATIQUEMENT. La capture fait 4,5 ecrans,
           la traversee n'en dure qu'une et demie : tout montrer obligerait le
           contenu a filer 1,6 fois plus vite que la page — ca se lit mal et ca
           donne le tournis. On plafonne a 1,15 fois la vitesse de la page,
           soit environ les trois quarts de la capture. Le dernier quart se
           prend au doigt, et c'est tres bien : ca donne une raison de toucher
           l'appareil. */
        var parcours = Math.min(course, plage * 1.15);
        ecran.scrollTop = p * parcours;
      }

      function onS() { if (!tick) { tick = true; requestAnimationFrame(frame); } }

      /* On ne se fie qu'aux evenements d'ENTREE. Ecouter « scroll » se
         mordrait la queue : notre propre `scrollTop` en declenche un. */
      function rendreLaMain() {
        if (libre) return;
        libre = true;
        window.removeEventListener('scroll', onS);
      }

      ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach(function (t) {
        ecran.addEventListener(t, rendreLaMain, { passive: true });
      });

      window.addEventListener('scroll', onS, { passive: true });
      window.addEventListener('resize', function () { course = 0; onS(); }, { passive: true });

      /* L'image arrive en differe (`loading="lazy"`) : sa hauteur n'existe pas
         encore au chargement, et `course` vaudrait zero pour toujours. */
      if (img.complete) mesurer();
      else img.addEventListener('load', function () { mesurer(); onS(); });

      frame();
      onCleanup(function () { window.removeEventListener('scroll', onS); });
    });
  }

  function init() {
    initScheme();
    initNav(); initReveals(); initCounters(); initFaq(); initFaqRepli(); initAvis();
    initHero(); initSpot(); initLightbox(); initDemo(); initContact(); initVisibilityAnimations();
    initEditorial(); initPoche();
  }
  function detruire() {
    cleanups.forEach(function (fn) { try { fn(); } catch (e) {} });
    cleanups = [];
    window.weblyRedessinerDemo = null;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }

  /* Editeur Shopify : rejouer l'initialisation apres chaque rechargement de
     section, et nettoyer avant de la retirer. */
  document.addEventListener('shopify:section:load', function () { detruire(); init(); });
  document.addEventListener('shopify:section:unload', detruire);
  document.addEventListener('shopify:section:select', function (e) {
    var d = $('[data-demo]', e.target);
    if (d) d.scrollIntoView({ block: 'center', behavior: 'smooth' });
  });
})();
